module.exports = __webpack_public_path__ + "static/media/doorOpen.9a3c32f3.mp3";